import React, { useEffect, useState, useRef } from "react";
import './SetSelection.css'
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import Box from "@mui/material/Box";


function SetSelection(props) {

    const sets = props.sets;
    const player = props.player;

    let popup = document.querySelector(".popup");

    function close() {
        props.closeSetSelection();
    }

    function closePopup() {
        props.closeSetSelection();
    }

    function test(e) {
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
    }

    function selectSet(set) {
        props.selectedSet(set, player);
        close()
    }

    function renderSets() {
        return (
            <div style={{ margin: '10px' }}>
                <List sx={{
                    width: '100%',
                    maxWidth: 360,
                    position: 'relative',
                    overflow: 'auto',
                    maxHeight: 300,
                    "&::-webkit-scrollbar": {
                        width: '10px',
                    },
                    "&::-webkit-scrollbar-track": {
                        backgroundColor: 'none',
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: '#555555',
                        borderRadius: '10px',
                        border: '1px solid black',
                    },
                    // hover states
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: '#242424',
                    },

                }}>
                    {sets.map((set) => (
                        <ListItemButton key={set.name} className='items' onClick={() => selectSet(set)}>
                            <ListItemText primary={`${set.name}`} />
                        </ListItemButton>
                    ))}
                </List>

            </div>
        )
    }

    return (
        <div>
            <div className="popup2" onClick={closePopup}>
                <div className='outer2'>
                    <div className="popup-inner2" onClick={test} >
                        <div style={{ textAlign: "center", fontSize: '24px', marginTop: '-30px', marginBottom: '20px', fontFamily: 'Noto Sans' }}>Select Set</div>
                        <div><Button className='close-btn2' variant="contained" onClick={close}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                        {renderSets()}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default SetSelection;